/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx } from '@emotion/react'
import { type FunctionComponent } from 'react'

import { FormattedMessage } from '@modules/i18n'

import BadgeList from '../../../components/BadgeList'
import { FIXED_RECIPIENTS } from '../../constants'
import DetailsSection from '../../../components/DetailsSection'

const Recipients: FunctionComponent = () => (
  <DetailsSection
    title={
      <FormattedMessage
        id='billing.notifications.budgets.budget-details.recipients.title'
        defaultMessage='Recipients'
      />
    }
    helpText={
      <FormattedMessage
        id='billing.notifications.budgets.budget-details.recipients.help'
        defaultMessage='Budget alerts will be sent to these roles in your organization.'
      />
    }
  >
    <BadgeList items={FIXED_RECIPIENTS} />
  </DetailsSection>
)

export default Recipients
